<script>
    //import * as Sentry from '@sentry/sveltekit';
    import * as Sentry from '@sentry/svelte';

    import { goto } from '$app/navigation';
    import { onMount } from "svelte";
    import { page } from '$app/stores';

    import { fly } from 'svelte/transition';
    import { flip } from 'svelte/animate';

    import Page from '$lib/Page.svelte';
    import MainMenu from '$lib/MainMenu.svelte';
    import Map from '$lib/app/Map.svelte';
    import Progress from './Progress.svelte';
    import BeenTable from './BeenTable.svelte';
    import BeenTableTCC from './BeenTableTCC.svelte';
    import BeenRegTree from './BeenRegTree.svelte';
    import NSWE from '$lib/app/NSWE.svelte';
    import Run from './Run.svelte';
    import VisitedContinents from '$lib/app/VisitedContinents.svelte';
    import MapSettings from './MapSettings.svelte';
    import RareRegionsList from "$lib/app/RareRegionsList.svelte";
    import UserLink from "./UserLink.svelte";
    import Avatar from '$lib/app/Avatar.svelte';
    import Flag from '$lib/app/Flag.svelte';
    
    import { rareness_levels, rareness_colors } from '$lib/universal/lib.js';
    import { Tabs, TabList, TabPanel, Tab } from '$lib/tabs.js';
    import { js } from '$lib/app/static.js';
    //import { static_data_totals } from '$lib/static/static_data_totals.js';
    //import { unp_arr } from '$lib/static/unp_arr.js';
    import { relative_time } from '$lib/universal/lib.js';
    import { tooltip } from '$lib/app/tooltip.js';
    import { activeUserData } from '$lib/app/activeUserData.svelte.js';

    import HoveredRegionName from './HoveredRegionName.svelte';
    import BeenTableSwitch from './BeenTableSwitch.svelte';

    let {
        data
    } = $props();

    let map = $state(null);
    let map_settings_override = $state({});


    let editable = $derived(data.session?.id && (data.session.id === data.profile?.id));  // Logged in and on his own page

    // Logged in user on his own page -- use editable active_user_data loaded from +layout instead of +page.server.js data
    let user_data = $derived(editable && activeUserData.data?.userpage &&
        (activeUserData.data.userpage == data.profile?.userpage) ? activeUserData.data : data);


    //$inspect('active_user_data.data = ' + JSON.stringify(active_user_data.data));
    //$inspect('active_user_data.data.userpage = ' + active_user_data.data?.userpage);
    //$inspect('editable = ' + editable);
    //$inspect('stats = ' + stats);
    //$inspect('user_data = ' + JSON.stringify(user_data));
    //$inspect('user_data?.stats?.un = ' + JSON.stringify(user_data?.stats?.un));
    //$inspect('user_data?.stats?.unp = ' + JSON.stringify(user_data?.stats?.unp));
    //$inspect('user_data?.stats?.tcc = ' + JSON.stringify(user_data?.stats?.tcc));
    //$inspect('user_data?.stats?.reg = ' + JSON.stringify(user_data?.stats?.reg));

    onMount(async function () {
        //console.log('js='+JSON.stringify(js));
        if($page.params.userpage == 'me') {
            if(data?.session?.userpage) {
                Sentry.captureMessage("/user/me redirect in onMount", {to_userpage: data?.session?.userpage});
                goto("/user/"+data.session.userpage);
            }
        }
        if(data.profile?.deleted) {
            goto("/settings");
        }
    });

    let rare_tcc = $derived(user_data?.stats?.rare_tcc);

    let un_switch_state = $state(1);
    let unp_switch_state = $state(1);
    let tcc_switch_state = $state(1);
    let reg_switch_state = $state(2);
    let selectedRegIntId = $state();
    let selectedRegType = $state();

    let current_unp = $state(null); // Will be link into my_reg_json
    let default_macro_reg = $state(null); // ID of the opened mac_reg

    let authentication_required = $derived($page.params.userpage == 'me');

</script>

<!--
{#snippet CategoryProgress(
        category="un",
        params={tab: false})}
    {@const visited = user_data?.stats?.[category]}
    {@const total = js.static_data_totals?.[category]}
    {@const old_visited = data?.old_stats?.[category]}
    {@const visited_cnt = (typeof visited === 'object' && visited !== null) ? Object.keys(visited).length : 0}
    {@const done_pc = Math.round(visited_cnt / total * 100)}
    {@const fly_direction = (visited_cnt > Number(old_visited)) ? -30: 30}
    {#key visited_cnt}
        <span
            style="display: inline-block"
            class:has-text-weight-semibold={!params.tab}
            class:has-text-success={!params.tab && (visited_cnt > Number(old_visited))}
            in:fly|local={{ y: fly_direction }}>
            {visited_cnt}
        </span>
    {/key}
    <span class:is-hidden-touch={params.tab}>
        &nbsp;/&nbsp;{total}&nbsp;({done_pc}%)
    </span>
{/snippet}-->


{#snippet CategoryProgress(category="un", params={tab: false})}
<Progress
    visited={user_data?.stats?.[category]}
    total={js.static_data_totals?.[category]}
    old_visited={data?.old_stats?.[category]}
    visited_bold={!params.tab}
    highlight_progress={!params.tab}
    shrink_on_mobile={params.tab}/>
{/snippet}


<MainMenu session={data.session} authentication_required={authentication_required}/>
<Map map_id="user" userpage={$page.params.userpage} {user_data} secret={data?.secret} bind:map bind:selectedRegIntId bind:selectedRegType bind:map_settings_override/>
<Page long_page_footer={true}>

    <div style="max-width:1100px;">
        
        <HoveredRegionName {selectedRegIntId} {selectedRegType}/>{#if import.meta.env.DEV}<dev style="font-size:0.9em;" id=zoom_level></dev>{/if}
        <Tabs group="t">
            <TabList>
                <Tab id=""><svg class='svg-icon'><use xlink:href='/i/fa.svg#person-walking-luggage'></use></svg>&nbsp;{#if data?.profile?.displayname}{data?.profile?.displayname}{/if}</Tab>
                <Tab id="un"><b>UN</b>&nbsp;{@render CategoryProgress("un", {tab:true})}</Tab>
                <Tab id="unp"><b>UN+</b>&nbsp;{@render CategoryProgress("unp", {tab:true})}</Tab>
                <Tab id="tcc"><b>TCC</b>&nbsp;{@render CategoryProgress("tcc", {tab:true})}</Tab>
                <Tab id="reg"><b>Reg</b>&nbsp;{@render CategoryProgress("reg", {tab:true})}</Tab>
                {#if editable}<Tab id="settings">&nbsp;<svg class='svg-icon'><use xlink:href='/i/fa.svg#sliders'></use></svg>&nbsp;</Tab>{/if}
            </TabList>
        
            <TabPanel>
                <Run effectFn={() => {map_settings_override = { 'select-regions': 'auto' }}} />
                {#if data?.avatar}<div class=mb-2><Avatar borderRadius="2px" name={data?.profile?.displayname} src={data.avatar.url}/></div>{/if}
                {#if data?.profile?.from1}
                    <span transition:fly={{ y: 150, duration: 300 }}>
                        <Flag reg={data?.profile?.from1} width=auto template="From %s"/>
                    </span>
                {/if}
                {#if data?.profile?.from2}
                    <Flag reg={data?.profile?.from2} template="Also from %s"/>
                {/if}
                {#if data?.profile?.age}<div class="has-text-grey" style="font-size: 0.8em; font-style: oblique;">Age: {data.profile.age}</div>{/if}
                {#each data.user_links as user_link}
                    <div>
                        <UserLink linkObj={user_link}/>
                    </div>
                {/each}
                {#if data?.profile?.bio}
                    <div>
                        <i id=bio>{data.profile.bio}</i>
                    </div>
                {/if}
                {#if Number(data?.profile?.trust) < 0}
                    <div class=is_fake>⚠️ This account has questionable travel stats. Trips to some places <a href=/info/terms#no-fraud>need to be verified</a></div>
                {/if}
                <div>Places visited: <Progress visited={user_data?.stats?.places_visited} old_visited={data?.old_stats?.places}/>
                    <!--
                {#key user_data?.stats?.places_visited} /*in:fly={{ y: -20 }*/ 
                    <b class:has-text-success={Number(user_data?.stats?.places_visited) > (data?.old_stats?.places ?? 0)}>{user_data?.stats?.places_visited ?? 0}</b>
                {/key}-->
                </div>
                <!-- svelte-ignore a11y_consider_explicit_label -->
                <div><b>Regions</b><a href=/info/our-regions#Regions target=_blank><sup><svg class='svg-icon'><use xlink:href='/i/fa.svg#circle-question'></use></svg></sup></a>:
                    {@render CategoryProgress("reg")}
                </div>
                <div><b>UN</b> member states: 
                    {@render CategoryProgress("un")}
                </div>
                <div><b>UN+</b> (Countries and territories): 
                    {@render CategoryProgress("unp")}
                </div>
                <!-- svelte-ignore a11y_consider_explicit_label -->
                <div><b>TCC</b><a href=https://travelerscenturyclub.org/countries-and-territories target=_blank><sup><svg class='svg-icon'><use xlink:href='/i/fa.svg#circle-question'></use></svg></sup></a> list of countries and territories: 
                    {@render CategoryProgress("tcc")}
                </div>
                <div><VisitedContinents user_tcc={user_data?.stats?.tcc}/></div><!-- tcc={$user_data?.stats.tcc} -->
                {#if user_data?.stats?.places_visited > 1}
                    <div transition:fly|local="{{ y: 150, duration: 300 }}">
                        <div>Northernmost: <NSWE nswe={user_data?.stats?.most_nothern} bind:map/></div><!-- map={map} -->
                        <div>Westernmost: <NSWE nswe={user_data?.stats?.most_western} bind:map/></div>
                        <div>Easternmost: <NSWE nswe={user_data?.stats?.most_eastern} bind:map/></div>
                        <div>Southernmost: <NSWE nswe={user_data?.stats?.most_southern} bind:map/></div>
                    </div>
                {/if}
                <!--RareRegions rare_tcc={$user_data?.stats?.rare_tcc}/-->
                {#each Object.keys(rare_tcc ?? {}).filter(i => rare_tcc?.[i]?.length > 0) as j (rare_tcc[j].join(", ")) }
                    <div animate:flip|local={{duration: 500}}><!--</div> transition:fly|local={{ y: 200, duration: 500 }}-->
                        <span use:tooltip data-tooltip={`Been to ${rareness_levels[j]} regions`}><svg class='svg-icon' style="color: {rareness_colors[j]};">
                            <use xlink:href='/i/fa.svg#circle-check'></use>
                        </svg></span>
                        <span style='vertical-align: middle;'>{rareness_levels[j]}: <RareRegionsList list={rare_tcc[j]}/></span>
                    </div> 
                {/each}
                {#if $page.params.userpage !== 'me'}
                    <div class:has-text-success={Object.keys(data?.old_stats).length === 0}>Joined: {#if data?.profile?.joined}{relative_time(data.profile.joined)}{/if}</div>
                {/if}
                <!--{#if data.session?.id == 1 && data?.profile?.last_update && relative_time(data.profile.last_update) != relative_time(data.profile.joined)}<div class:has-text-success={Object.keys(data?.old_stats).length === 0}>Last update: {relative_time(data.profile.last_update)}</div>{/if}-->

            </TabPanel>
            <TabPanel>
                <Run effectFn={() => {map_settings_override = { 'highlight-countries': 'un', 'select-regions': 'un' }}} />
                <!--MapSettingsOverride  map_settings={{ 'highlight-countries': 'yes' }}/-->
                <b>{data?.profile.displayname}</b>'s <a href=/info/our-regions target=_blank><b>UN</b></a> member states<span class="is-hidden-desktop">:</span><br/>
                <span class=is-hidden-desktop>{@render CategoryProgress("un")}</span>
                <p>&nbsp;</p>
                <BeenTableSwitch bind:switch_state={un_switch_state}/>
                <BeenTable bind:map  db={js.unp_arr} un193_only={true} user_stats={user_data?.stats?.un}  bind:switch_state={un_switch_state} bind:selectedRegIntId/>
            </TabPanel>
            <TabPanel>
                <!--MapSettingsOverride  map_settings={{ 'highlight-countries': 'yes' }}/-->
                <Run effectFn={() => {map_settings_override = { 'highlight-countries': 'yes', 'select-regions': 'unp' }}} />
                <!-- destroyFn={() => {map_settings_override = {}}} -->
                <b>{data?.profile.displayname}</b>'s <a href=/info/our-regions target=_blank><b>UN+</b></a> countries<!--sup><svg class='svg-icon'><use xlink:href='/i/fa.svg#circle-question'></use></svg></sup></a--><span class="is-hidden-desktop">:</span><br/>
                <span class=is-hidden-desktop>{@render CategoryProgress("unp")}</span>
                <p>&nbsp;</p>
                <BeenTableSwitch bind:switch_state={unp_switch_state}/>
                <BeenTable bind:map db={js.unp_arr} user_stats={user_data?.stats?.unp} bind:switch_state={unp_switch_state} bind:selectedRegIntId/>
                <!--br>
                <br>
                *&hairsp;{$user_data?.profile.displayname}'s visited <i><a href=https://en.wikipedia.org/wiki/Member_states_of_the_United_Nations target=_blank>UN members</a></i>, 
                <i><a href=https://en.wikipedia.org/wiki/United_Nations_General_Assembly_observers target=_blank>UN observer states</a></i>, 
                <i><a href=https://en.wikipedia.org/wiki/Dependent_territory target=_blank>dependent territories</a></i>, 
                and <i><a href=https://en.wikipedia.org/wiki/List_of_states_with_limited_recognition target=_blank>de-facto states</a></i-->
            </TabPanel>
            <TabPanel>
                <!--MapSettingsOverride  map_settings={{ 'highlight-countries': 'yes' }}/-->
                <Run effectFn={() => {map_settings_override = { 'highlight-countries': 'tcc', 'select-regions': 'tcc' }}} />
                <b>{data?.profile.displayname}</b>'s <a href=/info/our-regions target=_blank><b>TCC</b></a> (<i>Travelers’ Century Club’s</i>) countries and territories<span class="is-hidden-desktop">:</span><br/>
                <span class=is-hidden-desktop>{@render CategoryProgress("tcc")}</span>
                <p>&nbsp;</p>
                <BeenTableSwitch bind:switch_state={tcc_switch_state}/>
                <BeenTableTCC bind:map user_stats_tcc={user_data?.stats?.tcc} bind:switch_state={tcc_switch_state} bind:selectedRegIntId/>
                <!--br>
                <br>
                *&hairsp;{$user_data?.profile.displayname}'s visited <i><a href=https://travelerscenturyclub.org/countries-and-territories target=_blank>Travelers’ Century Club</a></i>’s states and territories
                <br>
                <br-->
            </TabPanel>
            <TabPanel>
                <!--MapSettingsOverride  map_settings={{ 'highlight-countries': 'reg', 'region-borders': 'all' }}/-->
                <Run effectFn={() => {map_settings_override = { 'highlight-countries': 'reg', 'region-borders': 'all', 'select-regions': 'reg' }}} />
                <b>{data?.profile.displayname}</b>'s <a href=/info/our-regions#Regions target=_blank><b>regions</b></a> (states, provinces, oblasts, archipelagos, etc)<span class="is-hidden-desktop">:</span><br/>
                <span class=is-hidden-desktop>{@render CategoryProgress("reg")}</span>
                <p>&nbsp;</p>
                <BeenRegTree bind:map user_stats_reg={user_data?.stats?.reg} bind:switch_state={reg_switch_state} bind:default_macro_reg bind:current_unp bind:selectedRegIntId/>
            </TabPanel>
            {#if editable}
            <TabPanel>
                <MapSettings bind:map bind:map_settings={user_data.map_settings} bind:map_settings_override/>
            </TabPanel>
            {/if}
        </Tabs>
    
    </div>
</Page>

<style>
#bio {
    white-space: pre;
}
</style>
